export default __webpack_public_path__ + "static/media/glasses-rgb.c627b671.svg";